import React, { FC } from 'react'

import ClearIcon from '@mui/icons-material/Clear'
import { Checkbox, FormControlLabel, IconButton, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useThemeMode } from '../../theme/ThemeModeContext'

import { CheckboxButtonProps } from './types'

export const CheckboxButton: FC<CheckboxButtonProps> = ({
  name,
  label,
  defaultValue,
  customValue,
  showDeleteButton,
  deleteCustomValue,
}) => {
  const { spacing, palette } = useTheme()
  const { resolvedMode } = useThemeMode()

  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <Box sx={{ position: 'relative' }}>
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                onChange={() => {
                  field.onChange(!field.value)
                }}
                sx={{ display: 'none' }}
              />
            }
            label={label || t(name)}
            sx={{
              width: 'fit-content',
              height: spacing(5.5),
              m: 0,
              paddingX: 3,
              border: `1px solid ${palette.grey[500]}`,
              borderRadius: spacing(2.75),
              ...(Boolean(field.value && resolvedMode === 'dark') && {
                borderColor: 'transparent',
              }),
              '& .MuiFormControlLabel-label': {
                width: '100%',
                fontWeight: 500,
                lineHeight: spacing(2.75),
                textAlign: 'center',
              },
              ...(field.value && {
                backgroundColor: resolvedMode === 'dark' ? '#0359A3' : palette.grey[300],
              }),
              '&:hover': {
                borderColor: palette.grey[600],
              },
            }}
          />
          {customValue && showDeleteButton && (
            <IconButton
              onClick={deleteCustomValue}
              sx={{
                position: 'absolute',
                width: spacing(2.5),
                height: spacing(2.5),
                border: `1px solid ${palette.grey[700]}`,
                backgroundColor: palette.primary.light,
                top: spacing(-0.5),
                right: spacing(-0.5),
                color: palette.red[700],
              }}
            >
              <ClearIcon sx={{ width: spacing(2), height: spacing(2) }} />
            </IconButton>
          )}
        </Box>
      )}
    />
  )
}
